import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const MaintenanceOrderDetailListState = Immutable.fromJS({
	orderId: '',
	orderDetailList: []
});

const maintenanceOrderDetailListReducer = handleActions({

	FIND_MAINTENANCE_ORDER_DETAIL_LIST: (state, { payload }) => {
		return state.merge({
			orderDetailList: payload.data
		})
	},
	CLOSE_MAINTENANCE_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			orderDetailList: []
		})
	}
}, MaintenanceOrderDetailListState);

export default maintenanceOrderDetailListReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceOrderDetailListReducer.js